module.exports = __webpack_public_path__ + "static/media/20201114_161019_743_IMG_0023.745f89f3.jpg";